<template>
  <div class="flex flex-col gap-[15px]">
    <div class="flex-grow flex flex-col relative overflow-hidden gap-[10px]">
      <div class="flex flex-col justify-between">
        <span class="text-[19px] font-medium">{{ title }}</span>
        <span class="text-[12px] font-medium text-[#b8b8b8] px-[6px]">
          {{ displayTime }}
        </span>
        <section class="absolute flex flex-row gap-[5px] top-0 right-0">
          <div v-show="isEvaluate !== evaluateMap.get('like') && isEvaluate !== evaluateMap.get('dislike')
            " @click="evaluateFunc('like')"
            class="flex gap-[2px] items-center cursor-pointer duration-300 opacity-60 hover:opacity-100">
            <img class="w-[14px] h-[14px]" :src="likePng" />
            <span class="text-[12px]">有帮助</span>
          </div>
          <div v-show="isEvaluate !== evaluateMap.get('like') && isEvaluate !== evaluateMap.get('dislike')
            " @click="evaluateFunc('dislike')"
            class="flex gap-[2px] items-center cursor-pointer duration-300 opacity-60 hover:opacity-100">
            <img class="w-[14px] h-[14px] transform rotate-180" :src="likePng" />
            <span class="text-[12px]">没帮助</span>
          </div>
          <div v-show="isEvaluate == evaluateMap.get('like')"
            class="flex gap-[2px] items-center select-none duration-300 opacity-100">
            <img class="w-[14px] h-[14px]" :src="likePng" />
            <span class="text-[12px]">有帮助</span>
          </div>
          <div v-show="isEvaluate == evaluateMap.get('dislike')"
            class="flex gap-[2px] select-none items-center duration-300 opacity-100">
            <img class="w-[14px] h-[14px] transform rotate-180" :src="likePng" />
            <span class="text-[12px]">没帮助</span>
          </div>
        </section>
        <section>
          <el-collapse class="el-collapse-item-custom" @change="handleChange">
            <el-collapse-item name="1">
              <template v-slot:title>
                <span class="collapse-title">基础信息</span>
              </template>
              <el-form label-suffix=":" label-position="left" label-width="100px" class="script-info-form">

                <el-form-item v-if="fieldShouldDisplay('product_name')" label="产品名称">
                  <span>{{ parentSnapshot?.product_name || '' }}</span>
                </el-form-item>
                <el-form-item v-if="fieldShouldDisplay('benefits')" label="利益点">
                  <span>{{ parentSnapshot?.benefits || '' }}</span>
                </el-form-item>
                <!-- <el-form-item v-if="fieldShouldDisplay('benefits_unfixed')" label="可变利益点">
                  <span>{{ parentSnapshot?.benefits_unfixed || '' }}</span>
                </el-form-item> -->
                <el-form-item v-if="fieldShouldDisplay('target_audience')" label="角色设定">
                  <span>{{ parentSnapshot?.target_audience || '' }}</span>
                </el-form-item>

                <div v-if="isIndustryIn([2])">
                  <div class="md-20 text-[15px] font-medium">脚本结构：</div>
                  <div class="ml-10">
                    <el-form-item v-if="fieldShouldDisplay('structure_begin')" label="开头吸睛">
                      <span>{{ joinstr(parentSnapshot?.structure_begin) }}</span>
                    </el-form-item>
                    <el-form-item v-if="fieldShouldDisplay('structure_transition')" label="激发兴趣">
                      <span>{{ joinstr(parentSnapshot?.structure_transition) }}</span>
                    </el-form-item>
                    <el-form-item v-if="fieldShouldDisplay('structure_middle')" label="产品优势">
                      <span>{{ joinstr(parentSnapshot?.structure_middle) }}</span>
                    </el-form-item>
                    <el-form-item v-if="fieldShouldDisplay('structure_end')" label="行动号召">
                      <span>{{ joinstr(parentSnapshot?.structure_end) }}</span>
                    </el-form-item>
                  </div>
                </div>


                <el-form-item v-if="fieldShouldDisplay('number_of_character')" label="口播类型">
                  <span>{{ parentSnapshot?.number_of_character || '' }}</span>
                </el-form-item>
                <el-form-item v-if="fieldShouldDisplay('character_profile')" label="演员角色">
                  <span>{{ parentSnapshot?.character_profile || '' }}</span>
                </el-form-item>

                <el-form-item v-if="fieldShouldDisplay('script_scene')" label="剧本场景">
                  <span>{{ parentSnapshot?.script_scene || '' }}</span>
                </el-form-item>
                <el-form-item v-if="fieldShouldDisplay('script_style')" label="剧本类型">
                  <span>{{ parentSnapshot?.script_style || '' }}</span>
                </el-form-item>
                <el-form-item v-if="fieldShouldDisplay('script_mode')" label="模式选择">
                  <span>{{ parentSnapshot?.script_mode || '' }}</span>
                </el-form-item>

              </el-form>
              <el-button @click="copyScriptInfo" type="primary" size="small" class="mt-3">
                一键复制基本信息
              </el-button>
            </el-collapse-item>
          </el-collapse>
        </section>
      </div>
      <div class="overflow-y-auto flex-grow custom-scroll inspiration" ref="inspirationRef">
        <MarkdownPreview :remarkPlugins="[remarkGfm]" class="result flex flex-col flex-1 h-full w-full"
          :source="currentResult.content" />
      </div>
    </div>

    <div :class="[
      'flex flex-col gap-[10px]',
      {
        disabled: currentResult.generateStatus === '生成中' || isScriptGenerating
      }
    ]">
      <div class="flex w-full justify-between items-center pl-[15px]">
        <div class="flex gap-[20px]">
          <div @click="handleFavorite"
            class="flex gap-[2px] items-center cursor-pointer duration-300 opacity-60 hover:opacity-100">
            <el-icon class="cursor-pointer">
              <i-ep-documentAdd />
            </el-icon>
            <span class="text-[12px]">保存至收藏夹</span>
          </div>
          <div class="flex gap-[2px] items-center cursor-pointer duration-300 opacity-60 hover:opacity-100"
            @click="handleEdit">
            <el-icon class="cursor-pointer"><i-ep-editPen /></el-icon>
            <span class="text-[12px]"> 编辑 </span>
          </div>

          <div class="flex gap-[2px] items-center cursor-pointer duration-300 opacity-60 hover:opacity-100"
            @click="copy">
            <el-icon class="cursor-pointer"><i-ep-documentCopy /></el-icon>
            <span class="text-[12px]"> 复制 </span>
          </div>
          <el-popconfirm width="220" confirm-button-text="确认" cancel-button-text="取消" @confirm="generateInsp"
            icon-color="#626AEF" title="确定重新生成？已有灵感将被覆盖。">
            <template #reference>
              <div class="flex gap-[2px] items-center cursor-pointer duration-300 opacity-60 hover:opacity-100">
                <el-icon class="cursor-pointer" color="red"><i-ep-refresh /></el-icon>
                <span class="text-[12px]">重新生成灵感 </span>
              </div>
            </template>
          </el-popconfirm>
        </div>

        <el-button size="small" color="#6a50fd" type="primary" @click="generateScript"
          v-if="isIndustryIn([1]) && !hasScript">
          <label class="cursor-pointer">生成剧本</label>
        </el-button>
      </div>
    </div>
    <div v-if="hasScript">
      <div class="border-horizontal bg-[#dfdfdf]"></div>
      <div class="mt-[20px]">
        <ScriptStreamHandler :taskDetail="{
          taskId: taskId,
          taskKey: scriptKey,
          inspKey: taskDetail.parent_key,
          key: scriptKey
        }" @watchScriptGenerateStatus="watchScriptGenerateStatus" />
      </div>
    </div>
  </div>

  <el-dialog v-model="outerVisible" title="编辑" width="50%" :before-close="handleClose" align-center>
    <el-input v-model="currentEdit.content" type="textarea" placeholder="请输入内容" :rows="25" resize="none" />

    <el-dialog v-model="innerVisible" width="500" append-to-body align-center>
      <span>内容尚未保存， 需要保存编辑内容吗？</span>

      <template #header="{ titleId, titleClass }">
        <div class="flex justify-between">
          <div class="flex items-center gap-[4px]">
            <div>
              <el-icon class="text-[red]"><i-ep-warningFilled /></el-icon>
            </div>
            <h4 :id="titleId" :class="titleClass">提示</h4>
          </div>
        </div>
      </template>
      <template #footer>
        <div class="dialog-footer">
          <el-button type="primary" @click="handleSave" color="#6a50fd" :loading="saveStatus">
            保存内容
          </el-button>
          <el-button @click="exitEdit">退出编辑</el-button>
        </div>
      </template>
    </el-dialog>

    <template #footer>
      <span class="dialog-footer">
        <el-button @click="outerVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSave" color="#6a50fd" :loading="saveStatus">保存</el-button>
      </span>
    </template>
  </el-dialog>
</template>
<script setup>
import { computed, reactive, ref, watch } from 'vue'
import likePng from '@/assets/dianzan.png'
import MarkdownPreview from '@uivjs/vue-markdown-preview'
import { evaluate, getTaskDetail, saveFavorite } from '@/service/task.js'
import { copyToClipboard, eventTrackingFunc } from '../../utils/utils'
import '@uivjs/vue-markdown-preview/markdown.css'
import remarkGfm from 'remark-gfm'
import dayjs from 'dayjs'
import { useTaskStore } from '../../store/taskStore'
import { useLLMStore } from '../../store/llm'
import { ElMessage } from 'element-plus'
import { storeToRefs } from 'pinia'

const taskStore = useTaskStore()
const { currentTaskDetail } = storeToRefs(taskStore)

const isIndustryIn = computed(() => (industryIds) => taskStore.isIndustryIn(industryIds))

const fieldShouldDisplay = computed(() => (field) => taskStore.fieldShouldDisplay(field))

const joinstr = (arr) => {
  if (!arr || arr.length === 0) {

    return ''
  }
  return arr.join('、')
}

const props = defineProps({
  taskDetail: {
    type: Object,
    required: true,
    validator: (value) => {
      if (!value) {
        console.warn('taskDetail is required')
        return false
      }

      return true
    }
  },
  index: {
    type: Number
  }
})

const llmStore = useLLMStore()
const parentSnapshot = computed(
  () => currentTaskDetail?.value?.generated_content[props.index]?.parent_snapshot
)
const saveStatus = ref(false)
const outerVisible = ref(false)
const innerVisible = ref(false)
const currentEdit = reactive({
  key: '',
  content: '',
  event: ''
})
const evaluateMap = new Map()
evaluateMap.set('like', 1)
evaluateMap.set('dislike', -1)
evaluateMap.set('default', 0)
const emits = defineEmits(['watchGenerateStatus', 'refresh', 'updateScroll'])
const hasScript = computed(() => {
  return results.value?.[scriptKey.value] && results.value?.[scriptKey.value].content
})
const taskId = computed(() => props.taskDetail.taskId)
const id = computed(() => props.taskDetail.id)
const parentKey = computed(() => props.taskDetail.parent_key)
const isEvaluate = computed(() => props.taskDetail.evaluate)
const inspirationRef = ref(null)
const results = computed(() => llmStore.results?.[taskId.value])
const isScriptGenerating = computed(() => {
  return (
    results.value?.[scriptKey.value]?.generateStatus === '生成中' ||
    results.value?.[scriptKey.value]?.generateStatus === '生成失败'
  )
})

const currentResult = computed(() => {
  return results.value?.[parentKey.value] ?? {}
})

const displayTime = computed(() => {
  if (!results.value?.[parentKey.value]?.create_time) return ''
  return dayjs(results.value?.[parentKey.value].create_time).format('YYYY-MM-DD HH:mm:ss')
})
const title = computed(() => {
  const [, key] = parentKey.value.split('_')
  return `${taskStore.currentTaskDetail.content.product_name}灵感-${key}`
})
const scriptKey = computed(() => {
  const [, key] = parentKey.value.split('_')
  return `script_${key}`
})
const inspParams = ref({
  variables: taskStore.variables,
  keys: [parentKey.value],
  llm_type: props.taskDetail.event,
  clear_keys: [parentKey.value],
  task_id: taskId.value,
  industry_id: taskStore.currentTaskDetail.industry_id
})

const scriptParams = ref({
  variables: {
    content: ''
  },
  keys: [scriptKey.value],
  llm_type: 'inspiration_to_script_table',
  clear_keys: [scriptKey.value],
  task_id: taskId.value,
  industry_id: taskStore.currentTaskDetail.industry_id
})
const generateScript = () => {
  scriptParams.value.variables.content = results.value[parentKey.value].content // 生成剧本
  taskStore.generateTask(scriptParams.value)
}
const clearAboutGenerate = (_key) => {
  const currentResultKeys = Object.keys(llmStore.results[taskId.value])
  currentResultKeys.forEach((resultKey) => {
    const [, key] = resultKey.split('_')
    if (key === _key) {
      llmStore.results[taskId.value][resultKey].content = ''
      llmStore.results[taskId.value][resultKey].create_time = ''
    }
  })
}

const handleChange = () => {
  // console.log(currentTaskDetail?.value?.generated_content[props.index]?.parent_snapshot, props.index, '---currentTaskDetail>>>', currentTaskDetail?.value?.generated_content)
}

const generateInsp = async () => {
  const [, key] = parentKey.value.split('_')
  clearAboutGenerate(key) // 清除生成的灵感
  await taskStore.generateTask(inspParams.value) // 重新生成灵感
  emits('updateScroll')
  emits('refresh', { taskId: taskId.value, type: 'regenerate', val: 0, id: id.value, parentKey })
}

const handleFavorite = async () => {
  try {
    const res = await saveFavorite({ task_id: taskId.value, key: parentKey.value })
    if (res.code === 0) {
      ElMessage.success('保存成功')
    }
  } catch (e) {
    console.log(e)
  }
}

const handleEdit = async () => {
  const key = parentKey.value
  outerVisible.value = true
  currentEdit.key = key // 编辑key
  currentEdit.content = results.value[key].content // 编辑内容
  const eventTrackingParmas = {
    customized_id: id.value + '',
    event_name: 'InspirationEdit',
    event_type: 'Click',
    event_time: 0,
    page_name: ''
  }
  const { data } = await getTaskDetail(taskId.value)
  const TaskItem = data.generated_content.filter((item) => item.parent_key == parentKey.value)[0]
  if (id.value !== undefined) {
    eventTrackingParmas.customized_id = id.value + ''
  } else {
    eventTrackingParmas.customized_id = TaskItem.id + ''
  }
  eventTrackingFunc(eventTrackingParmas)
}

const handleClose = () => {
  const isSame = currentEdit.content === results.value[parentKey.value].content // 判断是否相同
  if (isSame) {
    outerVisible.value = false
    currentEdit.key = null
    currentEdit.content = ''
    return
  } else {
    innerVisible.value = true
  }
}
const clearEditContent = () => {
  currentEdit.key = null
  currentEdit.content = ''
  currentEdit.event = ''
}

const exitEdit = () => {
  innerVisible.value = false
  outerVisible.value = false

  clearEditContent()
}

const handleSave = async () => {
  saveStatus.value = true
  try {
    const res = await taskStore.HandleInspirationUpdate(taskId.value, parentKey.value, {
      content: currentEdit.content
    })
    const { code, message } = res
    if (code === 0) {
      llmStore.updateResultContent(taskId.value, parentKey.value, currentEdit.content)
      currentEdit.key = null
      currentEdit.content = ''
      outerVisible.value = false
      innerVisible.value = false
      ElMessage.success('保存成功')
      const eventTrackingParmas = {
        customized_id: id.value + '',
        event_name: 'InspirationEditConfirm',
        event_type: 'Click',
        event_time: 0,
        page_name: ''
      }
      const { data } = await getTaskDetail(taskId.value)
      const TaskItem = data.generated_content.filter(
        (item) => item.parent_key == parentKey.value
      )[0]
      if (id.value !== undefined) {
        eventTrackingParmas.customized_id = id.value + ''
      } else {
        eventTrackingParmas.customized_id = TaskItem.id + ''
      }
      eventTrackingFunc(eventTrackingParmas)
    } else {
      ElMessage.error(message)
    }
  } catch (error) {
    ElMessage.error(error.message)
  } finally {
    saveStatus.value = false
  }
}

const copy = async () => {
  const markdownContent = currentResult.value.content
  if (!markdownContent) {
    ElMessage.warning('没有可复制的内容')
    return
  }

  const success = await copyToClipboard(markdownContent, 'text/markdown')
  if (success) {
    ElMessage.success('内容已复制到剪贴')
  }

  const eventTrackingParmas = {
    customized_id: id.value + '',
    event_name: 'InspirationCopy',
    event_type: 'Click',
    event_time: 0,
    page_name: ''
  }
  const { data } = await getTaskDetail(taskId.value)
  const TaskItem = data.generated_content.filter((item) => item.parent_key == parentKey.value)[0]
  if (id.value !== undefined) {
    eventTrackingParmas.customized_id = id.value + ''
  } else {
    eventTrackingParmas.customized_id = TaskItem.id + ''
  }
  eventTrackingFunc(eventTrackingParmas)
}

const evaluateFunc = async (val) => {
  const eventTrackingParmas = {
    customized_id: '',
    event_name: '',
    event_type: 'Click',
    event_time: 0,
    page_name: '',
    customized_type: '1'
  }
  const { data } = await getTaskDetail(taskId.value)
  const TaskItem = data.generated_content.filter((item) => item.parent_key == parentKey.value)[0]
  if (id.value !== undefined) {
    eventTrackingParmas.customized_id = id.value + ''
  } else {
    eventTrackingParmas.customized_id = TaskItem.id + ''
  }
  const res = await evaluate(taskId.value, parentKey.value, {
    evaluate: evaluateMap.get(val)
  })
  if (res?.code == 0) {
    if (val == 'like') {
      ElMessage.success('点赞成功')
      eventTrackingParmas.event_name = 'Like'
      emits('refresh', {
        val: evaluateMap.get(val),
        type: 'evaluate',
        parentKey,
        id: TaskItem.id,
        taskId: taskId.value
      })
    }
    if (val == 'dislike') {
      ElMessage.success('收到反馈')
      eventTrackingParmas.event_name = 'disLike'
      emits('refresh', {
        val: evaluateMap.get(val),
        type: 'evaluate',
        parentKey,
        id: TaskItem.id,
        taskId: taskId.value
      })
    }
  }
  eventTrackingFunc(eventTrackingParmas)
}

const watchScriptGenerateStatus = ({ key, status }) => {
  emits('watchGenerateStatus', { key, status })
}

watch(
  () => currentResult.value.generateStatus,
  (generateStatus) => {
    emits('watchGenerateStatus', { key: parentKey.value, status: generateStatus })
  },
  { immediate: true }
)
watch(
  () => props.taskDetail.evaluate,
  () => { },
  { deep: true, immediate: true }
)

const copyScriptInfo = () => {
  const fields = [
    'product_name',
    'benefits',
    'benefits_unfixed',
    'target_audience',
    'script_scene',
    'script_style',
    'script_mode',
    'structure_begin',
    'structure_end',
    'structure_middle',
    'structure_transition',
    'number_of_character',
    'character_profile'
  ].filter(field => !!taskStore.fieldShouldDisplay(field))
  const info = Object.fromEntries(fields.map(field => [field, parentSnapshot.value?.[field] || '']))
  copyToClipboard(JSON.stringify(info, null, 2), 'text/plain')

  // taskStore.updateBaseInfo(taskId.value, info)
}
</script>
<style lang="scss" scoped>
.custom-scroll {
  &::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #ccc;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-track {
    background-color: #f5f4ff;
    border-radius: 3px;
  }
}

.markdown-body {
  margin: 0;
  font-size: 14px;
  border-radius: 8px;
  background: rgba(106, 80, 235, 0.03);
  box-shadow: inset 0 0 3px 1px rgba(106, 80, 235, 0.1);
  padding: 15px;
  width: 100%;
  max-width: unset;

  hr {
    display: none;
  }
}

:deep(.markdown-body hr) {
  display: none !important;
}

:deep(.markdown-body *) {
  margin: 5px 0;
}

:deep(.markdown-body ul) {
  padding-left: 10px;
}

:deep(.markdown-body li) {
  margin: 5px 0;
}

:deep(.markdown-body a.anchor) {
  display: none;
}

:deep(.markdown-body h1) {
  font-size: 16px;
  line-height: normal;
  font-weight: normal;
}

:deep(.markdown-body h2) {
  font-size: 15px;
  line-height: normal;
  padding-bottom: 10px;
  font-weight: normal;
  border: none;
}

:deep(.markdown-body h3) {
  font-size: 14px;
  line-height: normal;
  font-weight: normal;
}

:deep(.markdown-body h4) {
  font-size: 13px;
  line-height: normal;
  font-weight: normal;
}

:deep(.markdown-body h5) {
  font-size: 12px;
  line-height: normal;
  font-weight: normal;
}

:deep(.el-textarea) {
  height: 100%;

  .el-textarea__inner {
    height: 100%;
  }
}

:deep(.el-textarea__inner) {
  font-size: 14px;
  background: #f7f7f7;
  box-shadow: none;
}

.tooltip-class {
  background: red !important;
}

.disabled {
  opacity: 0.35;
  pointer-events: none;
  cursor: not-allowed;
  user-select: none;
}

.error {
  box-shadow: inset 0 0 1px 1px red;
}

.list-enter-active,
.list-leave-active {
  transition: all 0.5s ease;
}

.list-enter-from,
.list-leave-to {
  opacity: 0;
  transform: translateX(30px);
}

.script-info-form {
  :deep(.el-form-item) {
    margin-bottom: 8px;
  }

  :deep(.el-form-item__label) {
    font-weight: bold;
    color: #606266;
  }

  :deep(.el-form-item__content) {
    color: #303133;
  }
}

// 添加一些按钮样式
.el-button {
  margin-top: 10px;
}

.collapse-title {
  flex: 1 0 0%; //位于左侧
  order: 1;
  text-align: left;
}

.el-collapse-item-custom {
  :deep(.el-icon) {
    left: 80px !important;
  }
}
</style>
